import styled, { css } from 'styled-components';
import { Badge as BaseBadge, surfaceLiquid02, text } from '@salutejs/plasma-core';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Badge/Badge');
export var badgeViews = {
  primary: /*#__PURE__*/css(["color:#226af1;background-color:rgba(34,106,241,0.09);"]),
  secondary: /*#__PURE__*/css(["color:", ";background-color:", ";"], text, surfaceLiquid02),
  success: /*#__PURE__*/css(["color:#09a552;background-color:rgba(9,165,82,0.08);"]),
  warning: /*#__PURE__*/css(["color:#ee6820;background-color:rgba(238,104,32,0.08);"]),
  critical: /*#__PURE__*/css(["color:#df2638;background-color:rgba(223,38,56,0.09);"])
};

/**
 * Небольшая бирка для ячеек и карточек.
 * Компонент может отображаться в нескольких размерах и цветах, может содержать текст и/или иконку.
 */
export var Badge = /*#__PURE__*/styled(BaseBadge).withConfig({
  componentId: "plasma-web-core__sc-50gfig-0"
})(["border-radius:0.25rem;", ""], function (_ref) {
  var _ref$view = _ref.view,
      view = _ref$view === void 0 ? 'primary' : _ref$view;
  return badgeViews[view];
});